export default "__VITE_PUBLIC_ASSET__6cc1f780__"